"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.clamp = void 0;

var clamp = function clamp(a, b, c) {
  return Math.max(a, Math.min(b, c));
};

exports.clamp = clamp;